var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tooltip-wrapper",
    { attrs: { tooltip: _vm.tooltipText, placement: _vm.placement } },
    [
      _c(
        "div",
        {
          class: _vm.componentState,
          attrs: { "data-component": "base-action-icon-button" },
          on: { click: _vm.onClick },
        },
        [
          _vm.isLoading
            ? _c("or-progress", { attrs: { type: "circle", loading: "" } })
            : _vm._e(),
          _vm._v(" "),
          _vm.icon && !_vm.isLoading
            ? _c("or-icon", { attrs: { icon: _vm.icon } })
            : _vm._e(),
          _vm._v(" "),
          _vm.content && !_vm.isLoading
            ? _c("div", { staticClass: "content" }, [
                _vm._v("\n      " + _vm._s(_vm.content) + "\n    "),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }